/* eslint-disable complexity */
import './index.scss'

import React from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'

const bem = new BEMHelper('icon')

export const ICONS = {
  time: [20, 20],
  place: [14, 20],
  more: [4, 18],
  search: [18, 18],
  menu: [23, 23],
  check: [15, 10],
  arrow: [16, 13],
  upAndDown: [9, 14],
  smallArrow: [12, 12],
  chevron: [6, 10],
  calendar: [18, 18],
  x: [13, 13],
  close: [14, 14],
  info: [4, 11],
  warning: [24, 24],
  notice: [24, 24],
  success: [19, 15],
  edit: [16, 16],
  open: [18, 18],
  box: [18, 18],
  trash: [23, 27],
  upload: [16, 18],
  plus: [12, 12],
  spinner: [12, 12],
  dot: [6, 6],
  sharing: [19, 28],
  mail: [23, 16],
  user: [16, 17],
  duplicate: [21, 16],
  print: [22, 20],
}

export type Props = {
  [key: string]: any
  icon: keyof typeof ICONS
  direction?: 'left' | 'up' | 'down' | 'left-up'
  className?: string
  title?: string
}

export default function Icon({ icon, direction, className, title, ...props }: Props) {
  if (ICONS[icon] == null) {
    return null
  }

  const [width, height] = ICONS[icon]

  return (
    <svg
      width={`${width}px`}
      height={`${height}px`}
      viewBox={`0 0 ${width} ${height}`}
      {...bem(
        '',
        {
          [icon]: Boolean(icon),
          ...(direction ? { [direction]: Boolean(direction) } : {}),
        },
        className,
      )}
      {...props}
    >
      {title && <title>{title}</title>}
      {icon === 'time' && (
        <g>
          <circle {...bem('line')} cx="10" cy="10" r="9" />
          <polyline {...bem('line')} points="10,4 10,10 13,12" />
        </g>
      )}
      {icon === 'place' && (
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.89062 11.4479C9.40755 11.4479 11.4479 9.40755 11.4479 6.89062C11.4479 4.3737 9.40755 2.33333 6.89062 2.33333C4.3737 2.33333 2.33333 4.3737 2.33333 6.89062C2.33333 9.40755 4.3737 11.4479 6.89062 11.4479ZM6.89062 19.9792C8.49479 19.9792 13.7812 11.4479 13.7812 6.89062C13.7812 2.33333 10.6962 0 6.89062 0C3.08504 0 0 2.33333 0 6.89062C0 11.4479 5.28646 19.9792 6.89062 19.9792Z"
            {...bem('fill')}
          />
        </g>
      )}
      {icon === 'more' && (
        <g>
          <circle {...bem('fill')} cx="2" cy="2" r="2" />
          <circle {...bem('fill')} cx="2" cy="9" r="2" />
          <circle {...bem('fill')} cx="2" cy="16" r="2" />
        </g>
      )}
      {icon === 'search' && (
        <g>
          <path
            d="M11.1823 11.3227C13.4802 9.02488 13.4802 5.29932 11.1823 3.00147C8.8845 0.703613 5.15894 0.703613 2.86109 3.00147C0.563232 5.29932 0.563232 9.02488 2.86109 11.3227C5.15894 13.6206 8.8845 13.6206 11.1823 11.3227ZM11.1823 11.3227L16.4777 16.6181"
            {...bem('line')}
          />
        </g>
      )}
      {icon === 'menu' && (
        <g>
          <line {...bem('line')} x1="1" y1="5" x2="23" y2="5" />
          <line {...bem('line')} x1="1" y1="13" x2="23" y2="13" />
          <line {...bem('line')} x1="1" y1="21" x2="23" y2="21" />
        </g>
      )}
      {icon === 'check' && (
        <g>
          <polyline {...bem('line')} points="1,5 5,9 13,1" />
        </g>
      )}
      {icon === 'arrow' && (
        <g>
          <line {...bem('line')} x1="1" y1="6.5" x2="14" y2="6.5" />
          <polyline {...bem('line')} points="9.5,1 15,6.5 9.5,12" />
        </g>
      )}
      {icon === 'upAndDown' && (
        <g>
          <polyline {...bem('fill')} points="0,4.5 4.5,0 9,4.5" />
          <polyline {...bem('fill')} points="0,9.5 4.5,14 9,9.5" />
        </g>
      )}
      {icon === 'smallArrow' && (
        <g>
          <line {...bem('line', 'thin')} x1="1" y1="6" x2="10.5" y2="6" />
          <polyline {...bem('line', 'thin')} points="6.5,1 11,6 6.5,11" />
        </g>
      )}
      {icon === 'chevron' && (
        <g>
          <polyline {...bem('line')} points="1,1 5,5 1,9" />
        </g>
      )}
      {icon === 'info' && (
        <g>
          <circle {...bem('fill')} cx="2" cy="2" r="1.32" />
          <line {...bem('line')} x1="2" y1="5.4" x2="2" y2="11" />
        </g>
      )}
      {icon === 'x' && (
        <g>
          <polyline {...bem('line')} points="1,1 6.5,6.5 1,12" />
          <polyline {...bem('line')} points="12,12 6.5,6.5 12,1" />
        </g>
      )}
      {icon === 'close' && (
        <g>
          <polyline {...bem('line')} points="1,1 13,13" />
          <polyline {...bem('line')} points="1,13 13,1" />
        </g>
      )}
      {(icon === 'warning' || icon === 'notice') && (
        <g>
          <path
            {...bem('fill')}
            d="M12,0C5.37,0,0,5.37,0,12c0,6.63,5.37,12,12,12s12-5.37,12-12C24,5.37,18.63,0,12,0z M13.67,19.17 c-0.38,0.38-0.89,0.56-1.54,0.56c-0.7,0-1.26-0.16-1.69-0.47C10,18.95,9.79,18.49,9.79,17.9c0-0.64,0.19-1.14,0.56-1.5 c0.38-0.36,0.89-0.54,1.54-0.54c0.71,0,1.28,0.15,1.7,0.45c0.43,0.3,0.64,0.75,0.64,1.36C14.24,18.29,14.05,18.79,13.67,19.17z M14.08,9.25c-0.4,1.87-0.82,3.44-1.25,4.71c-0.16,0.01-0.4,0.02-0.72,0.02s-0.57-0.01-0.72-0.02c-0.47-1.35-0.93-2.95-1.38-4.81 S9.28,5.82,9.21,4.74c1.86-0.17,3.72-0.17,5.58,0C14.72,5.87,14.48,7.38,14.08,9.25z"
          />
        </g>
      )}
      {icon === 'success' && (
        <g>
          <path d="M2 6.86364L7.81818 12.6818L17.5 1" {...bem('line', 'thick')} />
        </g>
      )}
      {icon === 'edit' && (
        <g>
          <polyline {...bem('line')} points="12,9.49 12,15 1,15 1,4 6,4" />
          <polygon {...bem('fill')} points="14.3,4.57 16,2.88 14.58,1.46 13.12,0 11.43,1.7" />
          <polygon {...bem('fill')} points="10.72,2.4 5.2,7.93 4,12 8.07,10.8 13.6,5.28" />
        </g>
      )}
      {icon === 'calendar' && (
        <g>
          <rect {...bem('line', 'square')} x="1" y="1" width="16" height="4" />
          <line {...bem('line', 'square')} x1="4" y1="9" x2="6" y2="9" />
          <line {...bem('line', 'square')} x1="8" y1="9" x2="10" y2="9" />
          <line {...bem('line', 'square')} x1="12" y1="9" x2="14" y2="9" />
          <line {...bem('line', 'square')} x1="4" y1="13" x2="6" y2="13" />
          <line {...bem('line', 'square')} x1="8" y1="13" x2="10" y2="13" />
          <line {...bem('line', 'square')} x1="12" y1="13" x2="14" y2="13" />
          <polyline {...bem('line')} points="1,5 1,17 17,17 17,5" />
        </g>
      )}
      {icon === 'open' && (
        <g>
          <polyline {...bem('line')} points="14,10.5 14,17 1,17 1,4 7,4 " />
          <g {...bem('arrow')}>
            <line {...bem('line')} x1="6" y1="12" x2="15.5" y2="2.5" />
            <polyline {...bem('line')} points="10,2 16,2 16,8" />
          </g>
        </g>
      )}
      {icon === 'trash' && (
        <g>
          <g {...bem('lid')}>
            <line {...bem('line')} x1="0" y1="9.8" x2="22" y2="9.8" />
            <path
              {...bem('line')}
              d="M7,9.8V8.3c0-0.8,0.8-1.5,1.7-1.5h4.5c1,0,1.7,0.7,1.7,1.5v1.5"
            />
          </g>
          <g>
            <path
              {...bem('line')}
              d="M19,10l-1,15c0,0.5-0.4,0.8-0.9,0.8H4.9C4.4,25.8,4,25.4,4,25L2.8,9.8"
            />
            <line {...bem('line')} x1="15" y1="12.8" x2="14.5" y2="22.8" />
            <line {...bem('line')} x1="11" y1="12.8" x2="11" y2="22.8" />
            <line {...bem('line')} x1="7" y1="12.8" x2="7.5" y2="22.8" />
          </g>
        </g>
      )}
      {icon === 'upload' && (
        <g>
          <g {...bem('arrow')}>
            <line {...bem('line')} x1="8" y1="14" x2="8" y2="5" />
            <polyline {...bem('line')} points="3.8,8.8 8,4.5 12.3,8.7" />
          </g>
          <polyline {...bem('line')} points="15,12.5 15,17 1,17 1,12" />
        </g>
      )}
      {icon === 'plus' && (
        <g>
          <line {...bem('line')} x1="0" y1="6" x2="12" y2="6" />
          <line {...bem('line')} x1="6" y1="12" x2="6" y2="0" />
        </g>
      )}
      {icon === 'spinner' && (
        <g>
          <circle
            r="5"
            cx="6"
            cy="6"
            {...bem('line', 'square')}
            style={{ strokeDasharray: '16 6' }}
          />
        </g>
      )}
      {icon === 'dot' && (
        <g>
          <circle {...bem('fill')} cx="3" cy="3" r="3" />
        </g>
      )}
      {icon === 'box' && (
        <g>
          <rect x="0" y="0" width="18" height="18" {...bem('line')} />
        </g>
      )}
      {icon === 'sharing' && (
        <g>
          <path
            {...bem('line')}
            d="M13.5 11.5H16.7C17.3 11.5 17.8 12 17.8 12.6V25.3C17.8 25.9 17.3 26.4 16.7 26.4H2.1C1.5 26.4 1 25.9 1 25.3V12.6C1 12 1.5 11.5 2.1 11.5H5.3M4.1 7.80002L9.4 2.40002L14.7 7.80002M9.4 2.90002V19"
          />
        </g>
      )}
      {icon === 'mail' && (
        <g>
          <path
            {...bem('fill')}
            d="M12.8168 9.28497C12.3779 9.69948 11.7634 9.86528 11.1489 9.86528C10.5344 9.86528 9.91985 9.69948 9.48092 9.28497L0.0877849 1.57513C-1.34082e-06 1.82383 0 1.98964 0 2.23834V13.6788C0 14.9223 1.05344 16 2.45802 16H20.542C21.8588 16 23 15.0052 23 13.6788V2.23834C23 1.82383 22.9122 1.49223 22.7366 1.16062L12.8168 9.28497Z"
          />
          <path
            {...bem('fill')}
            d="M10.6221 7.95855C10.8855 8.20725 11.3244 8.20725 11.5878 7.95855L21.1565 0.0829016C20.8931 1.85299e-08 20.7176 0 20.4542 0H2.37023C1.9313 0 1.58015 0.0829016 1.22901 0.248705L10.6221 7.95855Z"
          />
        </g>
      )}
      {icon === 'user' && (
        <g>
          <circle cx="8.0015" cy="6.01663" r="5.13333" {...bem('line')} />
          <path
            d="M15 16.7501V14.1501C15 12.4933 13.6569 11.1501 12 11.1501H4C2.34315 11.1501 1 12.4933 1 14.1501V16.7501"
            {...bem('line')}
          />
        </g>
      )}
      {icon === 'duplicate' && (
        <g>
          <path
            {...bem('fill')}
            d="M17.8629 13.7145C17.7257 12.343 17.04 11.3145 15.8743 10.5602C15.3181 10.2003 14.6528 9.93412 13.8857 9.7541V11.1087C14.3657 11.2459 14.7771 11.4516 15.12 11.6573C15.4628 11.863 15.7371 12.1373 16.0114 12.5488C16.2857 12.9602 16.4228 13.3716 16.4914 13.8516L16.6286 15.0859H18L17.8629 13.7145Z"
          />
          <path
            {...bem('fill')}
            d="M11.0056 8.36584C12.0342 8.36584 12.9256 7.9544 13.6799 7.06296C14.4342 6.17152 14.7771 5.07436 14.7085 3.84006C14.7085 3.15433 14.5714 2.53718 14.2285 1.92003C13.8857 1.37145 13.4057 0.891442 12.8571 0.54858C12.3085 0.205717 11.6913 0 11.0056 0V1.30288C11.6228 1.30288 12.2399 1.57717 12.7199 2.05717C13.1999 2.53718 13.4742 3.15433 13.4742 3.84006C13.4742 4.80007 13.2685 5.55437 12.7885 6.17152C12.3085 6.78867 11.7599 7.13153 11.0056 7.13153V8.36584Z"
          />
          <path
            {...bem('fill')}
            d="M1.33333 15H0L0.133333 13.6364C0.266667 12.2727 0.933333 11.1818 2.06667 10.5C3.2 9.81818 4.8 9.40909 6.8 9.40909C8.8 9.40909 10.4 9.75 11.5333 10.5C12.6667 11.25 13.3333 12.2727 13.4667 13.6364L13.6 15H12.2667L12.1333 13.7727C12.0667 13.2955 11.9333 12.8864 11.6667 12.4773C11.4 12.0682 11.1333 11.7955 10.8 11.5909C10.4667 11.3864 10.0667 11.1818 9.6 11.0455C9.13333 10.9091 8.66667 10.8409 8.2 10.7727C7.73333 10.7045 7.26667 10.7045 6.73333 10.7045C6.2 10.7045 5.73333 10.7045 5.26667 10.7727C4.93333 10.8409 4.46667 10.9091 4 11.0455C3.53333 11.1818 3.13333 11.3864 2.8 11.5909C2.46667 11.7955 2.13333 12.1364 1.93333 12.4773C1.66667 12.8182 1.53333 13.2955 1.46667 13.7727L1.33333 15ZM9.4 7.02273C8.66667 7.90909 7.8 8.31818 6.8 8.31818C5.8 8.31818 4.86667 7.90909 4.2 7.02273C3.53333 6.13636 3.13333 5.04545 3.13333 3.81818C3.13333 3.13636 3.26667 2.52273 3.6 1.90909C3.93333 1.29545 4.4 0.886364 4.93333 0.545455C5.46667 0.204545 6.13333 0 6.8 0C7.46667 0 8.06667 0.204545 8.6 0.545455C9.13333 0.886364 9.6 1.36364 9.93333 1.90909C10.2667 2.52273 10.4 3.13636 10.4 3.81818C10.4667 5.04545 10.1333 6.13636 9.4 7.02273ZM8.46667 2.04545C8 1.56818 7.4 1.29545 6.8 1.29545C6.2 1.29545 5.6 1.56818 5.13333 2.04545C4.66667 2.52273 4.4 3.13636 4.4 3.81818C4.4 4.70455 4.6 5.52273 5.06667 6.13636C5.53333 6.75 6.06667 7.09091 6.8 7.09091C7.53333 7.09091 8.06667 6.75 8.53333 6.13636C9 5.52273 9.2 4.77273 9.2 3.81818C9.2 3.13636 8.93333 2.52273 8.46667 2.04545Z"
          />
        </g>
      )}
      {icon === 'print' && (
        <path
          d="M4.79999 15.2H2.89999C1.69999 15.2 0.799988 14.3 0.799988 13.1V8.19999C0.799988 6.99999 1.69999 6.09999 2.89999 6.09999H18.2C19.4 6.09999 20.3 6.99999 20.3 8.19999V13.1C20.3 14.3 19.4 15.2 18.2 15.2H16.2M6.89999 13.5H14.1M16.2 8.39999H18.3M6.89999 16H14.1M15.8 6.09999H5.19999V1.99999C5.19999 1.29999 5.69999 0.799988 6.39999 0.799988H14.6C15.3 0.799988 15.8 1.29999 15.8 1.99999V6.09999ZM15 18.8H6.09999C5.49999 18.8 5.09999 18.3 5.09999 17.8V11.8C5.09999 11.2 5.59999 10.8 6.09999 10.8H15C15.6 10.8 16 11.3 16 11.8V17.8C16 18.3 15.6 18.8 15 18.8Z"
          {...bem('line')}
        />
      )}
    </svg>
  )
}

Icon.propTypes = {
  icon: T.oneOf(Object.keys(ICONS)).isRequired,
  color: T.string,
  direction: T.string,
  className: T.string,
  title: T.string,
}
